<template>
  <div class="container-fluid">
    <div class="row progress-steps">
      <template v-for="(s, k) in steps">
        <div class="col py-3 progress-steps-step" :class="getClasses(k)" :key="k">
          {{ k + 1 }} {{ s }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressSteps',

  props: {
    step: Number,
    steps: Array
  },

  methods: {
    getClasses (key) {
      return {
        'progress-steps-complete': this.stepIsComplete(key),
        'progress-steps-current': this.stepIsCurrent(key)
      }
    },

    stepIsComplete (key) {
      return (key + 1) < this.step
    },

    stepIsCurrent (key) {
      return (key + 1) === this.step
    }
  }
}
</script>
